import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";

export const indicativeMidTooltipValueGetter = (params: any): string | null => {
  if (params.data?.indicativeAsk && params.data?.indicativeBid) {
    if (params.data?.notationES) {
      const bid = returnDecimalFormatting(Number(params.data.indicativeBid), params.data.notationES);
      const ask = returnDecimalFormatting(Number(params.data.indicativeAsk), params.data.notationES);
      return bid + " / " + ask;
    }
    return params.data.indicativeBid + " / " + params.data.indicativeAsk;
  }
  return null;
};
